import { render } from "./trust-data-external-examiner-modal.html?vue&type=template&id=474eae80&scoped=true&ts=true&external"
import script from "./trust-data-external-examiner-modal.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-external-examiner-modal.ts?vue&type=script&lang=ts&external"

import "./trust-data-external-examiner-modal.scss?vue&type=style&index=0&id=474eae80&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474eae80"]])

export default __exports__